<template>
  <div class="nav" :class="{'nav-hide': !store.state.open.header}">
    <div class="header-shell">
      <div class="nav-content glass">
        <!-- 左侧：头像 -->
        <div class="nav-left">
          <router-link to="/" class="site-logo tooltip-wrap">
            <img src="@/assets/logo.webp" alt="logo" class="site-logo-img"/>
          </router-link>
          <template v-for="item in store.getters['menu/getMenuList']" :key="item.id">
            <!-- 普通路由菜单：router-link -->
            <router-link
                v-if="item.path"
                :to="item.path"
                class="nav-item"
            >
              {{ item.title }}
            </router-link>
            <!-- 自定义点击菜单，不是路由，普通a标签 -->
            <a
                v-else
                @click.prevent="onClickEvent(item.event)"
                class="nav-item"
            >
              {{ item.title }}
            </a>
          </template>
          <div class="search-item" @click.prevent="onClickEvent('searchbar')">
            <img src="@/assets/svg/searchbar.svg" alt="searchbar">
          </div>
        </div>

        <!-- 右侧：桌面登录 + 汉堡 -->
        <div class="nav-right">
          <!--新增竖杠分隔线 -->
          <div class="nav-separator"></div>
          <template v-if="isLogin">
            <a @click.prevent="onClickEditProfile()" class="nav-item">资料</a>
            <a class="nav-item" @click="logout">退出</a>
          </template>
          <router-link v-else to="/login" class="login-btn">登录</router-link>
          <button class="nav-menu-btn" :class="{ active: mobileMenuOpen }" @click="toggleMobileMenu">
            <span class="bar bar-top"></span>
            <span class="bar bar-bottom"></span>
          </button>
        </div>
      </div>
    </div>

    <!-- 弹窗移到nav直接子级，不受header-shell裁剪 -->
    <div class="mobile-dropdown glass" :class="{ open: mobileMenuOpen }">
      <div class="dropdown-inner">
        <template v-for="item in store.getters['menu/getMenuList']" :key="item.id">
          <router-link
              v-if="item.path"
              :to="item.path"
              class="dropdown-item"
              @click="closeMobileMenu"
          >
            {{ item.title }}
          </router-link>
          <a v-else
             @click.prevent="onClickEvent(item.event)"
             class="dropdown-item"
          >
            {{ item.title }}
          </a>
        </template>
        <!-- =========移动端登录状态分支新增========= -->
        <template v-if="isLogin">
          <div class="dropdown-divider"></div>
          <div class="dropdown-item" @click.prevent="onClickEditProfile()">资料</div>
          <div class="dropdown-item" @click.prevent="logout">退出</div>
        </template>
        <template v-else>
          <div class="dropdown-divider"></div>
          <router-link to="/login" class="dropdown-item">登录</router-link>
        </template>
      </div>
    </div>
  </div>
</template>

<script setup>
import {ref, onMounted, computed, onUnmounted} from 'vue'
import {useStore} from "vuex";
import showToast from "@/utils/toast";

const store = useStore();
//判断是否登陆
const isLogin = computed(() => store.state.userInfo.isLogin);
//手机端打开菜单
const mobileMenuOpen = ref(false)
//用户下拉菜单状态
const userMenuOpen = ref(false)
//退出按钮防抖动
const logoutLoading = ref(false)
//退出登陆
const logout = async () => {
  if (logoutLoading.value) {
    return
  }
  logoutLoading.value = true
  // 点击退出立刻关闭下拉菜单
  userMenuOpen.value = false
  try {
    await store.dispatch('userInfo/logout', store.state.userInfo.username)
    showToast('已成功退出登录', 'success')
    //直接重定向，自动清缓存
    setTimeout(() => {
      location.href = '/login'
    }, 500)
  } catch (e) {
    showToast(e.message)
  } finally {
    logoutLoading.value = false
  }
}

//点击页面空白关闭用户菜单
const closeUserMenu = () => {
  userMenuOpen.value = false
}
//菜单配置的meta中的event
const onClickEvent = (event) => {
  if (event) {
    store.commit(`open/${event}`,true)
    if ('searchbar'=== event){
      store.commit(`open/header`,false)
    }
    closeMobileMenu()
  } else {
    console.error("please config meta.event")
    showToast("please config meta.event")
  }
}
//资料触发事件
const onClickEditProfile = () => {
  store.commit('open/editProfile', true)
  closeMobileMenu()
}
//关闭手机端窗口
const toggleMobileMenu = () => {
  if (mobileMenuOpen.value) {
    closeMobileMenu()
  } else {
    mobileMenuOpen.value = true
    document.body.classList.add('lock-scroll')
  }
}

const closeMobileMenu = () => {
  mobileMenuOpen.value = false
  document.body.classList.remove('lock-scroll')
}

// 全局键盘监听
const handleKeyDown = (e) => {
  // Ctrl+K / Cmd+K 唤起搜索（**不带Shift**）
  if ((e.ctrlKey || e.metaKey) && !e.shiftKey && e.key.toLowerCase() === 'k') {
    e.preventDefault()
    onClickEvent('searchbar')
  }
}

onMounted(() => {
  //refresh()
  // 全局监听点击，空白处关闭用户下拉
  document.addEventListener('click', closeUserMenu)
  document.addEventListener('keydown', handleKeyDown)
})

onUnmounted(() => {
  document.removeEventListener('click', closeUserMenu)
  document.removeEventListener('keydown', handleKeyDown)
})
</script>

<style scoped>
.nav-separator {
  width: 2px;
  height: 24px;
  background-color: var(--laputa-glass-header-separator);
}

.nav {
  display: flex;
  width: 100%;
  position: fixed;
  z-index: 99;
  left: 0;
  bottom: 0;
  padding: 0;
  pointer-events: none;
  transition: transform 0.32s ease-out;
}
.nav.nav-hide{
  transform: translateY(-100%);
}

.header-shell {
  display: inline-block;
  max-width: 90%;
  border-radius: 999px;
  border: 1px solid transparent;
  transform-origin: center center;
  transition: all 0.24s cubic-bezier(0.25, 0.8, 0.25, 1);
  pointer-events: auto;
  margin-right: 0;
}

.header-shell:hover {
  transform: scale(1.05);
  border-color: var(--laputa-glass-border-hover);
  box-shadow: var(--laputa-glass-shadow)
}

.nav-content {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  border-radius: inherit;
  padding: 12px 20px;
}

.nav-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

img.site-logo-img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: contain;
}

.site-logo {
  display: flex;
  align-items: center;
  text-decoration: none;
}

.nav-item {
  cursor: pointer;
  color: var(--laputa-common-font-color);
  opacity: 0.8;
  transition: ease-in-out 0.22s;
  font-size: var(--laputa-fontsize-15);
  padding: 6px 10px;
  border-radius: 16px;
  text-decoration: none;
  border: 1px solid transparent;
  white-space: nowrap;
}

.nav-item:hover {
  opacity: 1;
  background-color: var(--laputa-card-background-white-trans);
  color: var(--laputa-primary);
  border-color: var(--laputa-primary);
  transform: scale(1.03);
}

.search-item {
  color: var(--laputa-space-black);
  opacity: 0.8;
  transition: ease-in-out 0.22s;
  font-size: var(--laputa-fontsize-15);
  padding: 5px 10px 0 10px;
  border-radius: 16px;
  border: 1px solid transparent;
  white-space: nowrap;
}
.search-item:hover {
  cursor: pointer;
}
.nav-right {
  display: flex;
  align-items: center;
  gap: 10px;
}

.login-btn {
  background-color: var(--laputa-card-background-private-blue);
  color: var(--laputa-white);
  padding: 8px 22px;
  border-radius: 999px;
  text-decoration: none;
  font-size: var(--laputa-fontsize-15);
  transition: background 0.22s ease;
  white-space: nowrap;
}

.login-btn:hover {
  background-color: var(--laputa-card-background-near-blue);
}

.nav-menu-btn {
  display: none;
  width: 32px;
  height: 32px;
  position: relative;
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 4px;
  border-radius: 8px;
  transition: background 0.22s ease;
}

.nav-menu-btn:hover {
  background: rgba(0, 0, 0, 0.06);
}

.nav-menu-btn .bar {
  position: absolute;
  left: 2px;
  width: 24px;
  height: 2px;
  background: var(--laputa-common-font-color);
  border-radius: 2px;
  transition: transform 0.32s cubic-bezier(0.28, 0, 0.12, 1),
  opacity 0.32s cubic-bezier(0.28, 0, 0.12, 1);
}

.nav-menu-btn .bar-top {
  top: 10px;
  transform-origin: center center;
}

.nav-menu-btn .bar-bottom {
  bottom: 10px;
  transform-origin: center center;
}

.nav-menu-btn.active .bar-top {
  transform: translateY(6px) rotate(45deg);
}

.nav-menu-btn.active .bar-bottom {
  transform: translateY(-6px) rotate(-45deg);
}

.mobile-dropdown {
  position: absolute;
  right: 48px;
  bottom: calc(100% + 12px);
  width: 220px;
  overflow: hidden;
  border-radius: 16px;
  max-height: 0;
  opacity: 0;
  transform: translateY(8px);
  transition: max-height 0.32s cubic-bezier(0.25, 1.2, 0.25, 1),
  opacity 0.28s ease,
  transform 0.28s ease;
  pointer-events: auto;
}

.mobile-dropdown.open {
  max-height: 70vh;
  opacity: 1;
  transform: translateY(0);
  overflow-y: auto;
}

.dropdown-inner {
  padding: 16px 18px;
  opacity: 0;
  transform: translateY(12px);
  transition: opacity 0.28s ease 0.08s, transform 0.28s ease 0.08s;
}

.mobile-dropdown.open .dropdown-inner {
  opacity: 1;
  transform: translateY(0);
}

.dropdown-item {
  display: block;
  padding: 10px 10px;
  font-size: var(--laputa-fontsize-15);
  color: var(--laputa-common-font-color);
  cursor: pointer;
  border-radius: 12px;
  margin: 2px 0;
  text-decoration: none;
  transition: background 0.2s ease, transform 0.18s ease;
  opacity: 0;
  transform: translateY(8px);
}

.mobile-dropdown.open .dropdown-item {
  opacity: 1;
  transform: translateY(0);
}

.dropdown-item:hover {
  background: rgba(0, 0, 0, 0.05);
}

.dropdown-divider {
  height: 1px;
  background: rgba(0, 0, 0, 0.08);
  margin: 10px 4px 12px 4px;
  opacity: 0;
  transform: translateY(8px);
  transition: opacity 0.28s ease 0.18s, transform 0.28s ease 0.18s;
}

.mobile-dropdown.open .dropdown-divider {
  opacity: 1;
  transform: translateY(0);
}

@media (min-width: 769px) {
  .nav {
    top: 0;
    bottom: auto;
    justify-content: center;
    padding: 8px 0;
  }

  .header-shell {
    margin-right: 0;
  }

  .login-btn {
    display: block;
  }

  .nav-menu-btn {
    display: none;
  }

  .mobile-dropdown {
    display: none;
  }
}

@media (max-width: 768px) {
  .nav-separator {
    display: none;
  }
  .nav {
    bottom: 0;
    top: auto;
    justify-content: flex-end;
    padding: 0 20px 24px 0;
  }

  .header-shell {
    margin-right: 10px;
    width: auto;
    display: inline-block;
  }

  .nav-content {
    gap: 20px;
    height: 56px;
    padding: 0 18px;
  }

  .nav-left .nav-item {
    display: none !important;
  }

  .nav-left .site-logo {
    display: flex !important;
  }

  img.site-logo-img {
    width: 36px;
    height: 36px;
  }

  .login-btn {
    display: none;
  }

  .nav-menu-btn {
    display: block;
  }
  .nav-right .nav-item {
    display: none !important;
  }
}
</style>